import React, { Component } from "react";
import { Input, Button, Col, Popconfirm, Form, Table, Divider, DatePicker } from "antd";
import "../App.css";
import { Link } from 'react-router-dom'
import moment from 'moment';

// We import our firestore module
import { db } from '../firebase/firebase';

const InputGroup = Input.Group;


//=================editable==========================
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
//=================editable==========================

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <DatePicker />;
    }
    return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: true,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

export class Events extends Component {
  constructor(props) {
    super(props);

    // Set the default state of our application
    this.state = {
      addingEvent: false,
      pendingTitle: "",
      pendingDate: moment(),
      sortdate: moment(),
      allowDelete: true,

      data: [],
      mama: [],
      jj: [],
      editingKey: '',
      da: null,
      ta: null,
    };
    this.columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: '20%',
        editable: false,
        sorter: (a, b) => parseInt(a.sortdate, 10) - parseInt(b.sortdate, 10),
      },
      {
        title: 'Name',
        dataIndex: 'title',
        editable: true,
        sorter: (a, b) => { return a.title.localeCompare(b.title) },
      },
      {
        title: '',
        dataIndex: 'unitno',
        width: '10%',
        editable: false,
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              <Button type="primary"><Link to={'/dashboard/events/' + this.state.data[record.key].id + "/" + this.state.data[record.key].title}>Media</Link></Button>
            </div>
          );
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <a
                        href="#"
                        onClick={() => this.save(form, record.key)}
                        style={{ marginRight: 8 }}
                      >
                        Save
                      </a>
                    )}
                  </EditableContext.Consumer>
                  <a href="#" onClick={() => this.cancel(record.key)}>Cancel</a>
                </span>
              ) : (
                  <div>
                    <Button
                      onClick={() => this.edit(record.key)}
                      className="App-t"
                    >
                      Edit
                </Button>
                    <Divider type="vertical" />

                    <Popconfirm
                      title="Confirm Delete?"
                      onConfirm={evt => this.deleteEntry(record.key)}
                    >
                      <Button
                        className="App-t"
                      >
                        Delete
                </Button>
                    </Popconfirm>

                  </div>
                )}
            </div>
          );
        },
      },
    ];

    // We want event handlers to share this context
    this.addEvent = this.addEvent.bind(this);
    this.deleteEntry = this.deleteEntry.bind(this);
    this.deleteTheEvent = this.deleteTheEvent.bind(this);
    this.updateEvent = this.updateEvent.bind(this);
    this.handleChange = this.handleChange.bind(this);
    //start the engine
    this.pullFromDB();
  }

  pullFromDB() {
    // We listen for live changes to our events collection in Firebase
    db.collection("events").onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });

      // Sort our events based on time added
      data.sort(function (a, b) {
        return (
          new Date(b.sortdate).getTime() - new Date(a.sortdate).getTime()
        );
      });

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }
      // console.log(data);


      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })
  }


  async deleteTheEvent(id) {
    console.log("delete event")
    await db
      .collection("events")
      .doc(this.state.data[id].id)
      .delete();

  }



  async deleteEntry(pid) {
    await db.collection("eventmedia").where("event", "==", this.state.data[pid].id).onSnapshot(snapshot => {
      let mama = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        mama.push(todo);
      });
      if (mama.length === 0) {
        this.deleteTheEvent(pid);
      } else {
        alert("Delete the associating media first.")
      }
    })
  }


  async updateEvent(id) {
    // console.log("update! record.key: " + id + "todo id: " + this.state.data[id].id)
    // console.log("firebasing the pa ta xa...: " + this.state.da + this.state.ta)
    await db
      .collection("events")
      .doc(this.state.data[id].id).update({
        //to do in the future: maybe convert the user editted date into isostring format, so can store together
        date: this.state.da,
        title: this.state.ta,
      })
      .then(function () {
        console.log("Document successfully updated!");

      })
      .catch(function (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
  }

  async addEvent() {
    //if no title, prohibit adding new event
    if (!this.state.pendingTitle) return;

    // Set a flag to indicate loading
    this.setState({ addingEvent: true });

    // Add a new event from the value of the input
    // console.log("adding event titled: ", this.state.pendingTitle)
    var bb = await db.collection("events").add({
      sortdate: this.state.pendingDate.toISOString(),
      date: this.exportTime(this.state.pendingDate),
      title: this.state.pendingTitle,
    });

    // Remove the loading flag and clear the input
    this.setState({ addingEvent: false, pendingTitle: "", pendingDate: moment(), sortdate: moment() });
  }

  handleChange(date) {
    this.setState({
      pendingDate: date,
      sortdate: date
    });
  }


  exportTime(x) {
    // var a = x.format("DD-MM-YYYY");
    var a = x.format("DD-MM-YYYY");
    return a;
  }

  importTime(s) {
    var v = new Date(s);
    return v.toLocaleString();
  }













  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    this.setState({ editingKey: key });
  }

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });

        this.state.da = newData[index].date
        this.state.ta = newData[index].title

        // alert("OLD DATA: " + JSON.stringify(this.state.data[index]))
        // alert("the pa ta xa...: " + this.state.pa + this.state.ta + this.state.xa + this.state.ya + this.state.sa)

        this.updateEvent(index)
        this.setState({ data: newData, editingKey: '' });
      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  }

  cancel = () => {
    this.setState({ editingKey: '' });
  };











  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'age' ? 'number' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });


    return (
      <div>
        <h1>Events</h1>
        <InputGroup size="large">
          <Col span={5}>
            <DatePicker
              size="large"
              ref="add-todo-input"
              className="inputt"
              format="DD-MM-YYYY"
              disabled={this.state.addingTodo}
              selected={this.state.pendingDate}
              onChange={this.handleChange}
              value={this.state.pendingDate}
            />
          </Col>
          <Col span={8}>
            <Input
              ref="add-todo-input"
              className="inputt bp3-input .bp3-large"
              size="large"
              placeholder="Title"
              disabled={this.state.addingEvent}
              onInput={evt => this.setState({ pendingTitle: evt.target.value })}
              value={this.state.pendingTitle}
              required
            />
          </Col>
          <Col span={4}>
            <Button
              className="inputt App-add-todo-button"
              size="large"
              type="primary"
              onClick={this.addEvent}
              loading={this.state.addingEvent}
            >
              Add Event
          </Button>
          </Col>
        </InputGroup>










        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
        />





        {/* <List
            className="App-todos"
            size="large"
            bordered
            dataSource={this.state.todos} //all the content arrays, *render item* is specific content of array
            renderItem={todo => (
              <List.Item>
                {todo.date} {}
                {todo.content} {'  MYR '}
                {todo.amount}
                <Icon
                  onClick={evt => this.deleteEntry(todo.id)}
                  className="App-todo-complete"
                  type="cross"
                />
              </List.Item>
            )}
          /> */}
      </div>
    )
  }
}
export default Events;



// WEBPACK FOOTER //
// ./src/views/events.js